L.Filter.Like = L.Filter.extend({
    defaultOptions: {
        escapeChar: "!",
        singleChar: "#",
        wildCard: "*",
        matchCase: false
    },

    initialize: function(options) {
        L.setOptions(this, L.extend({}, this.defaultOptions, options));
        L.Filter.prototype.initialize.call(this);
    },

    append: function (name, val) {
        let likeElement = L.XmlUtil.createElementNS('ogc:PropertyIsLike', {
            escapeChar: this.options.escapeChar,
            singleChar: this.options.singleChar,
            wildCard: this.options.wildCard,
            matchCase: this.options.matchCase
        });

        let nameElement = L.XmlUtil.createElementNS('ogc:PropertyName', {}, {value: name});
        let valueElement = L.XmlUtil.createElementNS('ogc:Literal', {}, {value: val});

        likeElement.appendChild(nameElement);
        likeElement.appendChild(valueElement);
        this.filter.appendChild(likeElement);
        return this;
    }
});



// WEBPACK FOOTER //
// ./src/components/WFSTFilterLike.js